{
	"title": "{{productName}} transaksjonslogg",
	"item": {
		"time": "Tid",
		"description": "Beskrivelse",
		"transactionId": "Transaksjons-ID",
		"showIds": "Vis ID-er",
		"depositTitle": "Assurance fra DNV, tillater et karbonbankinnskudd",
		"depositDescription": "Når tredjeparts forsikringsorganet 'DNV' har forsikret det lagrede fangede karbonvolumet i et digitalt Monitor-Report-Verify-system, foretas et nytt innskudd i karbonbanken.",
		"withdrawalTitle": "Faktura til leverandør som utløser et karbonbankuttak",
		"withdrawalDescription": "Med fakturering av evoZero-materiale til leverandøren er det gjennomført et uttak fra karbonbanken.",
		"transferTitle": "Overføring av karbonreduksjoner til deklarasjonsinnehaver",
		"transferDescription": "Leverandøren startet overføringen av karbonreduksjonene til deklarasjonsinnehaveren, basert på evoZero-materialvolumet som gikk inn til det leverte produktet."
	},
	"proofIdsModal": {
		"titleTransactions": "Se transaksjoner",
		"titleMeasurements": "Se mål",
		"paragraph1": "Ett transaksjonstrinn på {{productName}} involverer aggregering av transaksjoner på den distribuerte hovedboken. Nedenfor finner du en liste over lenker til tredjepartstjenester hvor du kan se disse transaksjonene.",
		"paragraph2": "Vær oppmerksom på at disse koblingene tar deg til eksterne nettsteder som tilbyr transaksjonsvisningsmuligheter.",
		"open": "Åpne",
		"close": "Lukk"
	},
	"errors": {
		"fetch": "Kunne ikke hente aktivitetsloggen"
	}
}
